import { render, staticRenderFns } from "./EnlacePersonaMoldeMaquina.vue?vue&type=template&id=9a413a96&"
import script from "./EnlacePersonaMoldeMaquina.vue?vue&type=script&lang=js&"
export * from "./EnlacePersonaMoldeMaquina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports